import { useQuery } from "@tanstack/react-query";
import { AccountStatusVariant } from "../constants";
import { useAuthContext } from "providers/Auth";
import { instance } from "api/apiBase";

const query = "portal/v1/customers/all";

const getSubscribers = async (type?: string) => {
  return instance
    .get(query, {
      params: {
        per_page: 1,
        page: 1,
        search: "",
        type,
        order_direction: "desc",
        order_by: "id"
      }
    })
    .then(({ data }) => data);
};

export const useCountMetaRentReportingController = () => {
  const { type } = useAuthContext();

  const pendingCountMeta = useQuery({
    queryKey: [
      query + "__total",
      {
        page: 1,
        per_page: 1,
        type: AccountStatusVariant.Pending,
        search: ""
      }
    ],
    queryFn: () =>
      getSubscribers(AccountStatusVariant.Pending).then((d) => {
        return d.total_count;
      }),
    enabled: type.isSDK
  });

  const needToReportCountMeta = useQuery({
    queryKey: [
      query + "__total",
      {
        page: 1,
        per_page: 1,
        type: AccountStatusVariant.NeedToReport
      }
    ],
    queryFn: () =>
      getSubscribers(AccountStatusVariant.NeedToReport).then((d) => {
        return d.total_count;
      }),
    enabled: type.isRentReporting && !type.isSDK
  });

  return {
    pendingCountMeta,
    needToReportCountMeta
  };
};
